"use client";
import { getApiBasePath } from "@/app/base-path";

export async function validatePatient(params: Record<string, unknown>): Promise<any> {
  const url = `${getApiBasePath()}/api/validate-patient/`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(params),
  });

  const responseBody = await response.json();

  if (!response.ok) {
    throw new Error(`Unexpected response status: ${response.status}`);
  }

  return responseBody;
}
